function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-undef */
import { make } from 'vuex-pathify';
import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

require('formdata-polyfill');

var state = {
  id: '',
  form: {},
  products: [],
  sidepanel: {},
  title: '',
  notification: false,
  showError: false,
  errorMessage: '',
  files: {},
  valid: [],
  currentStep: 0,
  currentSubStep: 0,
  totalSteps: 0,
  formName: '',
  steps: [],
  endpoint: '',
  redirect: '',
  submitted: false,
  showingLoader: false,
  submissionRecipient: '',
  countries: 'all',
  retrievingDosageForms: false,
  dosageFormsRetrieved: false,
  dosageForms: [],
  dosageFormId: '',
  showSpecificQuestions: false,
  labels: window.labels || {
    submit: 'Submit',
    "continue": 'Continue',
    ruleInvalidDate: 'Invalid Date.',
    ruleFormat: 'Invalid Format.',
    ruleInvalidDateFormat: 'Invalid date format.',
    ruleRequired: 'Required.',
    ruleInvalidEMail: 'Invalid e-mail.',
    errorMessage: 'Error on submission.',
    previousStep: 'Previous step'
  },
  fallbackValue: null,
  showGenentechThankYou: false,
  genentechCaseNumber: '',
  genentechData: {
    isGenentechForm: false,
    replacementProductIds: []
  }
};

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  handleStringProductInput: function handleStringProductInput(state, _ref) {
    var index = _ref.index,
        value = _ref.value;
    // handle TE form edge case when product list is disabled
    state.form.products[index].product = {
      label: value,
      value: value
    };
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  productLabel: function productLabel(state) {
    if (state.form.product) {
      if (state.form.product.label) {
        return state.form.product.label;
      }

      return state.form.product;
    }

    return '';
  },
  fullDosageForm: function fullDosageForm(state) {
    if (state.form.dosageForm || state.form.proceduralStep) {
      return state.dosageForms.find(function (dosageForm) {
        return dosageForm.id === state.dosageFormId;
      });
    }

    return false;
  },
  fullDosageFormDefectLocations: function fullDosageFormDefectLocations(state) {
    if (!getters.fullDosageForm(state)) {
      return false;
    }

    var level2Images = getters.fullDosageForm(state).images.find(function (image) {
      return image.hierarchyLevel === '2';
    });

    if (!level2Images) {
      return false;
    }

    return level2Images;
  },
  fullDosageFormHandlingSteps: function fullDosageFormHandlingSteps(state) {
    if (!getters.fullDosageForm(state)) {
      return false;
    }

    var targetHierarchyLevel = getters.isSusvimoFlow(state) ? '4' : '3';
    var level3Images = getters.fullDosageForm(state).images.filter(function (image) {
      return image.hierarchyLevel === targetHierarchyLevel;
    });

    if (!level3Images) {
      return false;
    }

    level3Images.map(function (image) {
      image.orderNo = parseInt(image.orderNo, 10);
      return image;
    });
    return sortBy(level3Images, 'orderNo');
  },
  fullDosageFormSpecificQuestions: function fullDosageFormSpecificQuestions(state) {
    if (!getters.fullDosageForm(state)) {
      return false;
    }

    var specificQuestions = [];
    getters.fullDosageFormHandlingSteps(state).forEach(function (step) {
      if (step.questionsAnswers) {
        specificQuestions.push.apply(specificQuestions, _toConsumableArray(step.questionsAnswers));
      }
    });
    var deduped = uniqBy(specificQuestions, 'questionId');
    var parsed = deduped.map(function (image) {
      image.displayOrder = parseInt(image.displayOrder, 10);
      return image;
    });
    return sortBy(parsed, 'displayOrder');
  },
  dosageFormsHaveLevel1Image: function dosageFormsHaveLevel1Image(state) {
    if (!state.dosageForms) {
      return false;
    }

    return state.dosageForms.some(function (dosageForm) {
      return dosageForm.images.some(function (image) {
        return image.hierarchyLevel === '1';
      });
    });
  },
  isSusvimoFlow: function isSusvimoFlow(state) {
    if (!state.dosageForms) {
      return false;
    }

    return state.dosageForms.length && state.genentechData.isGenentechForm && !getters.dosageFormsHaveLevel1Image(state);
  },
  susvimoProceduralSteps: function susvimoProceduralSteps(state) {
    if (!state.dosageForms) {
      return false;
    }

    var items = state.dosageForms[0].images.filter(function (dosageFormImage) {
      return dosageFormImage.proceduralStep && dosageFormImage.hierarchyLevel === '2';
    });
    items.forEach(function (item) {
      item.parentId = state.dosageForms[0].id;
    });
    return items;
  },
  susvimoLevel3Images: function susvimoLevel3Images(state) {
    if (!state.dosageForms || !state.dosageForms.length || !state.form.proceduralStep) {
      return [];
    }

    var filteredImages = state.dosageForms[0].images.filter(function (dosageFormImage) {
      return dosageFormImage.hierarchyLevel === '3' && dosageFormImage.proceduralStep === state.form.proceduralStep.trim();
    });
    var parsed = filteredImages.map(function (image) {
      image.orderNo = parseInt(image.orderNo, 10);
      return image;
    });
    return sortBy(parsed, 'orderNo');
  },
  susvimoLevel4Images: function susvimoLevel4Images(state) {
    if (!state.dosageForms || !state.form.proceduralStep) {
      return [];
    }

    var filteredImages = state.dosageForms[0].images.filter(function (dosageFormImage) {
      return dosageFormImage.hierarchyLevel === '4' && dosageFormImage.proceduralStep === state.form.proceduralStep.trim();
    });
    var parsed = filteredImages.map(function (image) {
      image.orderNo = parseInt(image.orderNo, 10);
      return image;
    });
    return sortBy(parsed, 'orderNo');
  }
});

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  preProcessFromData: function preProcessFromData(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var state, formattedFormData, unknownProductLabel, backupValue, unknownProduct, product, products, parsedProducts;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref2.state;
              formattedFormData = _objectSpread({}, state.form);
              unknownProductLabel = 'Not applicable';
              backupValue = 'Other';

              if (state.fallbackValue) {
                unknownProductLabel = state.fallbackValue;
              }

              unknownProduct = state.products.find(function (product) {
                return String(product.label).toLowerCase() === unknownProductLabel.toLowerCase() || String(product.label).toLowerCase() === backupValue.toLowerCase();
              }) || {
                value: '',
                label: ''
              };
              product = formattedFormData.product; // In temperature excursion form several products are possible

              products = formattedFormData.products;

              if (state.form.productUnknown === true) {
                formattedFormData.productId = unknownProduct.value || '';
                formattedFormData.productValue = unknownProduct.label || '';
              } else if (product) {
                formattedFormData.productId = _typeof(product) === 'object' ? product.value : unknownProduct.value;
                formattedFormData.productValue = _typeof(product) === 'object' ? product.label : product;

                if (_typeof(product) !== 'object') {
                  formattedFormData.productUnknown = true;
                }
              } else {
                formattedFormData.productId = unknownProduct.value;
                formattedFormData.productValue = product;
                formattedFormData.productUnknown = true;
              } // kcw-3044-fe-task-pt-form-product-selection
              // hardcode "Other" as product value if PT form is submitted with "Other" product


              if (formattedFormData.product && formattedFormData.product.id === 'OTHER_PRODUCT_ID') {
                formattedFormData.productValue = 'Other';
                formattedFormData.productId = '';
                formattedFormData.productUnknown = true;
              }

              delete formattedFormData.product;

              if (products) {
                // TE form can have multiple products so we need to handle the products array
                parsedProducts = products.map(function (productObj) {
                  var product = productObj.product; // TODO: check if other props are empty strings and delete those too if they are

                  if (productObj.unitsAffected === '') {
                    Reflect.deleteProperty(productObj, 'unitsAffected');
                  }

                  if (_typeof(product) !== 'object') {
                    var productObject = _objectSpread(_objectSpread({}, productObj), {}, {
                      productId: unknownProductLabel,
                      productValue: product
                    });

                    Reflect.deleteProperty(productObject, 'product');
                    return productObject;
                  }

                  productObj.productId = product.value || unknownProductLabel;
                  productObj.productValue = product.label || '';
                  Reflect.deleteProperty(productObj, 'product');
                  return productObj;
                });

                if (products[0].productValue !== '') {
                  formattedFormData.products = JSON.stringify(parsedProducts);
                  Reflect.deleteProperty(formattedFormData, 'productId');
                  Reflect.deleteProperty(formattedFormData, 'productValue');
                  Reflect.deleteProperty(formattedFormData, 'productUnknown');
                } else {
                  Reflect.deleteProperty(formattedFormData, 'products');
                }
              } // https://3share.atlassian.net/browse/RMI3-3245
              // PT Form: Purchase Location displayed as Country Code


              if (_typeof(formattedFormData.countryOfPurchase) === 'object') {
                formattedFormData.countryOfPurchase = formattedFormData.countryOfPurchase.label;
              }

              if (formattedFormData.susvimoData) {
                formattedFormData.susvimoData = JSON.stringify(formattedFormData.susvimoData);
              }

              return _context.abrupt("return", formattedFormData);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  submit: function submit(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var state, commit, rootState, dispatch;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref3.state, commit = _ref3.commit, rootState = _ref3.rootState, dispatch = _ref3.dispatch;
              commit('SET_FORM', state.form);

              if (!state.submitted) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              commit('SET_SHOW_ERROR', false);
              commit('SET_ERROR_MESSAGE', state.labels.errorMessage);
              commit('SET_TOTAL_STEPS', String(state.steps.length));
              commit('SET_FORM_NAME', state.id);
              _context3.prev = 8;
              return _context3.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var form, siteLocale, formattedForm, key, _loop, _key;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        form = new FormData();
                        siteLocale = document.querySelector('html').getAttribute('lang');

                        if (siteLocale) {
                          form.set('siteLocale', siteLocale);
                        }

                        form.set('form-id', state.id);
                        form.set('notification', state.notification);
                        form.set('ctr', rootState.ctr.toLowerCase());
                        _context2.next = 8;
                        return dispatch('preProcessFromData');

                      case 8:
                        formattedForm = _context2.sent;

                        for (key in formattedForm) {
                          if ({}.hasOwnProperty.call(formattedForm, key)) {
                            if (formattedForm[key] && formattedForm[key].value) {
                              form.set(key, formattedForm[key].value);
                            } else if (Array.isArray(formattedForm[key])) {
                              form.set(key, formattedForm[key].map(function (result) {
                                return result.label ? result.label : result;
                              }).join(', '));
                            } else {
                              form.set(key, formattedForm[key]);
                            }
                          }
                        } // Delete flagged countries before submit #RMI3-2616


                        form["delete"]('flaggedcountries');
                        form["delete"]('flaggedcountriesmap');

                        _loop = function _loop(_key) {
                          if ({}.hasOwnProperty.call(state.files, _key)) {
                            var files = state.files[_key];
                            files.forEach(function (file, index) {
                              return form.append("".concat(_key, "[").concat(index, "]"), file);
                            });
                          }
                        };

                        for (_key in state.files) {
                          _loop(_key);
                        }

                        commit('SET_SHOWING_LOADER', true);
                        axios({
                          method: 'post',
                          url: state.endpoint,
                          data: form,
                          headers: {
                            'content-type': "multipart/form-data; boundary=".concat(form._boundary)
                          }
                        }).then(function (_ref4) {
                          var data = _ref4.data;
                          commit('SET_SUBMITTED', true);
                          var sentFormType = Object.keys(data.data)[0];
                          var recipient = data.data[sentFormType];
                          commit('SET_SUBMISSION_RECIPIENT', recipient);

                          if (state.genentechData.isGenentechForm) {
                            commit('SET_SHOWING_LOADER', false);
                            commit('SET_SHOW_GENENTECH_THANK_YOU', true); // store recipient as genentech case number to remove possible side effects
                            // since submission recipient persists over page reloads with vuex-persist

                            commit('SET_GENENTECH_CASE_NUMBER', recipient);
                          } else {
                            // eslint-disable-next-line no-restricted-globals
                            location.href = state.redirect;
                          }
                        })["catch"](function (error) {
                          commit('SET_SUBMITTED', false);
                          commit('SET_SHOWING_LOADER', false);

                          if (error.response.data.error) {
                            commit('SET_ERROR_MESSAGE', error.response.data.error);
                            commit('SET_SHOW_ERROR', true);
                          }
                        });

                      case 16:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })(), "t0", 10);

            case 10:
              _context3.next = 19;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t1 = _context3["catch"](8);
              commit('SET_SUBMITTED', false);
              commit('SET_SHOWING_LOADER', false);
              commit('SET_SHOW_ERROR', true);
              console.error(_context3.t1);

              if (window.analytics) {
                window.analytics.isError = String(true);
              }

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[8, 12]]);
    }))();
  },
  lastPage: function lastPage(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;

    if (state.currentSubStep === 0) {
      commit('SET_CURRENT_STEP', state.currentStep - 1);
      var step = state.steps[state.currentStep];
      commit('SET_CURRENT_SUB_STEP', step.substeps - 1);
    } else {
      commit('SET_CURRENT_SUB_STEP', state.currentSubStep - 1);
    }
  },
  nextPage: function nextPage(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state,
        dispatch = _ref6.dispatch;
    var step = state.steps[state.currentStep];

    if (state.currentStep + 1 === state.steps.length && state.currentSubStep + 1 === step.substeps) {
      dispatch('submit');
    } else if (state.currentSubStep + 1 === step.substeps) {
      commit('SET_CURRENT_STEP', state.currentStep + 1);
      commit('SET_CURRENT_SUB_STEP', 0);
    } else {
      commit('SET_CURRENT_SUB_STEP', state.currentSubStep + 1);
    }
  },
  loadProducts: function () {
    var _loadProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref7) {
      var state, commit, rootState, params, ctr, _yield$axios$post, errors, data, products, urlParams, miId, miProduct, message;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref7.state, commit = _ref7.commit, rootState = _ref7.rootState;

              if (!(state.id === 'product-complaint')) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              params = new URLSearchParams();
              ctr = state.form.ctr || rootState.ctr;
              params.append('form-id', 'query');
              params.append('query', "{'query': 'query {products (input:\"".concat(ctr.toUpperCase(), "\") { title value } }'}"));

              if (!(state.endpoint && ctr)) {
                _context4.next = 29;
                break;
              }

              _context4.prev = 8;
              _context4.next = 11;
              return axios.post(state.endpoint, params);

            case 11:
              _yield$axios$post = _context4.sent;
              errors = _yield$axios$post.errors;
              data = _yield$axios$post.data;

              if (!(errors && errors.length > 0)) {
                _context4.next = 16;
                break;
              }

              return _context4.abrupt("return");

            case 16:
              if (!(!data || !data.data)) {
                _context4.next = 18;
                break;
              }

              return _context4.abrupt("return");

            case 18:
              products = data.data.products;
              products = products.map(function (product) {
                return {
                  label: product.title,
                  value: product.value
                };
              });
              commit('SET_PRODUCTS', products);
              urlParams = new URLSearchParams(window.location.search);

              if (urlParams.get('mi')) {
                miId = urlParams.get('mi');
                miProduct = products.find(function (product) {
                  return product.value === miId;
                });

                if (miProduct) {
                  if (state.id === 'temperature-excursion') {
                    state.form.products[0].product = miProduct;
                  } else {
                    state.form.product = miProduct;
                  }
                }
              }

              _context4.next = 29;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](8);
              message = _context4.t0.message;
              console.log('Unable to load products:', message);

            case 29:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[8, 25]]);
    }));

    function loadProducts(_x) {
      return _loadProducts.apply(this, arguments);
    }

    return loadProducts;
  }(),
  loadDosageForms: function () {
    var _loadDosageForms = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref9) {
      var state, commit, params, productVal, locale, _yield$axios$post2, errors, data, dosages, message;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref9.state, commit = _ref9.commit;
              params = new URLSearchParams();
              productVal = state.form.product.value;
              locale = document.documentElement.lang;
              commit('SET_DOSAGE_FORMS_RETRIEVED', false);
              commit('SET_RETRIEVING_DOSAGE_FORMS', true);

              if (productVal) {
                _context5.next = 11;
                break;
              }

              // either no product or custom string product
              commit('SET_DOSAGE_FORMS', []);
              commit('SET_DOSAGE_FORMS_RETRIEVED', true);
              commit('SET_RETRIEVING_DOSAGE_FORMS', false);
              return _context5.abrupt("return");

            case 11:
              params.append('form-id', 'query');
              params.append('query', // eslint disable-next-line
              "{'query': 'query {dosages(input: \"".concat(productVal, "\", locale: \"").concat(locale, "\") { id images { imageID parentID hierarchyLevel orderNo proceduralStep imageLabel imageValue imageDAMPathActive imageDAMPath questionsAnswers {questionId displayOrder questionText multipleAnswers answers {value label}} imageSections {orderNo dimension percentage imageSectionID imageSectionLabel imageSectionValue}}} }'}"));
              _context5.prev = 13;
              _context5.next = 16;
              return axios.post(state.endpoint, params);

            case 16:
              _yield$axios$post2 = _context5.sent;
              errors = _yield$axios$post2.errors;
              data = _yield$axios$post2.data;

              if (!(errors && errors.length > 0)) {
                _context5.next = 21;
                break;
              }

              return _context5.abrupt("return");

            case 21:
              if (!(!data || !data.data)) {
                _context5.next = 23;
                break;
              }

              return _context5.abrupt("return");

            case 23:
              dosages = data.data.dosages;
              commit('SET_DOSAGE_FORMS_RETRIEVED', true);
              commit('SET_RETRIEVING_DOSAGE_FORMS', false);

              if (dosages) {
                _context5.next = 28;
                break;
              }

              return _context5.abrupt("return");

            case 28:
              commit('SET_DOSAGE_FORMS', dosages);
              _context5.next = 35;
              break;

            case 31:
              _context5.prev = 31;
              _context5.t0 = _context5["catch"](13);
              message = _context5.t0.message;
              console.log('Unable to load dosage forms:', message);

            case 35:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[13, 31]]);
    }));

    function loadDosageForms(_x2) {
      return _loadDosageForms.apply(this, arguments);
    }

    return loadDosageForms;
  }(),
  replaceMarkupVariables: function replaceMarkupVariables(_ref11, element) {
    var state = _ref11.state;
    var found = false;
    if (!element) return;
    element.innerHTML = element.innerHTML.replace(/\$\{\{(.*?)\}\}/g, function (_match, p1) {
      var keys = p1.split('.');

      if (keys[1]) {
        keys[1] = keys[1].replace('lastName', 'surname');
      }

      if (state[keys[0]]) {
        found = true;
        return state[keys[0]][keys[1]] || '';
      }

      return '';
    }); // eslint-disable-next-line consistent-return

    return found;
  },
  analytics: function analytics(_ref12) {
    var state = _ref12.state;

    try {
      // eslint-disable-next-line no-unused-expressions
      window.digitalData.page.formInfo.formProgress = _objectSpread(_objectSpread({}, window.digitalData.page.formInfo.formProgress), {}, {
        recipient: state.submissionRecipient,
        isSubmitted: String(true),
        country: state.form.ctr
      });
    } catch (error) {
      console.error(error);
    }
  },
  confirmCountry: function confirmCountry() {}
});

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};